import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Passenger } from '@app/models/micro';
import { truncateText } from '@app/utils';

@Component({
    selector: 'am-passenger-list-priority-code-item',
    templateUrl: './am-passenger-list-priority-code-item.component.html',
    styleUrls: ['./am-passenger-list-priority-code-item.component.scss'],
    standalone: false
})
export class AmPassengerListPriorityCodeItemComponent implements OnInit {

  @Input() passenger: any;
  @Input() numberList: number;
  @Input() typeList: 'upgrade' | 'standby'  = 'upgrade';

  constructor() { }

  ngOnInit() {
    this.passenger.displayName = this.passenger.firstName + ' '+ this.passenger.lastName
  }

  truncateTextUi(elementTXt, maxLength = '20') {
    const truncated = truncateText(elementTXt, maxLength);
    return new TitleCasePipe().transform(truncated);
  }

  privatedName(passenger) {
    const lastNamePart = passenger?.lastName?.substring(0, 3).toUpperCase() || '';
    const firstNamePart = passenger?.firstName?.charAt(0).toUpperCase() || '';

    return `${lastNamePart}/${firstNamePart}`;
  }

}
